import React from "react";
import "./ticket.scss";

export default function Ticket() {
	return (
		<div class="ticket-wrap">
			<div class="ticket">
				<div class="ticket__header">
					<svg width="180" fill="none" viewBox="0 0 160 76">
						<defs />
						<path
							fill="#2E2205"
							d="M30.7653 75.0824s6.2681-19.6172 3.6109-30.4295c-2.6571-10.8122-10.0338-14.4483-15.238-15.2909-5.2044-.8425-11.8338.5302-11.1068 7.9992.7009 7.2013 8.1783 6.6754 9.2818 3.7579 1.5524-4.1041-1.7945-5.3561-4.6832-5.6316 0 0 1.6467-1.4579 3.5408-1.08 1.8939.3779 4.5547 2.9306 4.4126 6.1782-.142 3.2475-1.8775 6.5869-9.194 6.1546-7.3167-.4322-12.543-8.7271-11.1697-15.7666 1.3734-7.0395 10.9965-12.4979 20.2118-10.6378 9.2152 1.8601 17.2733 11.2334 18.7319 20.4235 2.0052 13.7982-2.5473 27.0285-2.5473 27.0285s8.3738-6.6517 10.7137-11.8535c2.3399-5.2019 5.1664-11.8536 2.5075-25.9865 5.1673 1.5957 11.7469 8.0944 14.5242 13.9649 2.7772 5.8706 4.5905 13.4969 3.332 22.5074 5.0654-2.6364 6.0627-8.381 6.6048-15.2059.1316-1.6554-.0902-4.2797-.3607-7.4809v-.0044c-.844-9.9954-2.1626-25.61 5.2997-34.9137C89.0909-3.4698 102.334-1.6297 110.807 6.492c3.055 2.9286 5.488 7.1268 7.907 11.299 4.29 7.3987 8.531 14.7156 16.106 14.7258 11.845.0161 15.016-7.544 15.271-11.1782.254-3.634-.755-10.3004-7.33-10.4822-6.575-.1818-5.837 8.0413-3.388 8.6673 1.878.4799 2.572-.4295 3.396-1.5091l.001-.0014c.25-.3281.512-.6717.823-.9969 1.037 4.597-4.212 7.6668-9.502 4.0439-5.29-3.6228-4.375-10.6888-1.206-13.6104 3.168-2.9216 11.248-5.9611 18.618-.779 7.37 5.1821 7.302 12.1469 6.912 16.6561-.39 4.5091-7.113 14.0693-18.514 14.3971-11.4.3277-16.297-3.1511-24.116-11.3049l-.192-.2004c-7.721-8.0517-13.389-13.9626-20.9252-12.4554-7.5985 1.5197-13.7707 7.8519-14.9105 15.7541-.4944 3.4278-.3474 7.7406-.1953 12.2027.1985 5.8248.4057 11.9038-.7941 16.5993-1.7725 6.9379-10.3991 17.0763-14.8736 16.9909.8462-13.1144-1.8113-28.6242-8.1303-30.6215 0 0-.8989 20.991-24.9987 30.3936z"
						/>
						<path
							fill="#2E2205"
							fill-rule="evenodd"
							d="M93.0348 49.5638c-5.4749 0-9.9131 4.4383-9.9131 9.9131 0 5.4749 4.4382 9.9131 9.9131 9.9131 5.4748 0 9.9132-4.4382 9.9132-9.9131 0-5.4748-4.4384-9.9131-9.9132-9.9131zm0 4.4774c3.0026-.0003 5.4369 2.4333 5.4374 5.4358.0003 3.0031-2.4342 5.4377-5.4374 5.4373-3.0025-.0005-5.4362-2.4348-5.4358-5.4373.0005-3.0019 2.434-5.4354 5.4358-5.4358z"
							clip-rule="evenodd"
						/>
						<path
							fill="#2E2205"
							d="M105.774 68.6617V50.5395h4.487l7.747 10.0299V50.5395h4.559v18.1222h-4.559l-7.747-10.6758v10.6758h-4.487zM125.439 50.5395v18.1222h5.238v-5.8402l4.632 5.8402 5.902.0537-7.361-9.4798 7.468-8.6961h-6.278l-4.363 4.3462v-4.3462h-5.238z"
						/>
						<path
							fill="#2E2205"
							fill-rule="evenodd"
							d="M143.207 68.662l5.662-18.1225h4.486L160 68.662h-4.813l-1.176-2.8839h-4.79l-1.272 2.8839h-4.742zm9.696-7.0625l-1.601-3.6002-1.542 3.6002h3.143z"
							clip-rule="evenodd"
						/>
					</svg>
				</div>
				<div style={{ padding: "0.1rem 0" }}></div>
				<h5 class="ticket__heading" data-text="Startup weekend">
					Startup Weekend
				</h5>
				<div class="ticket__details">
					<div class="ticket__detail">
						<div>Date</div>
						<div>March 25 - 27</div>
					</div>

					<div class="ticket__detail">
						<div>Time</div>
						<div>6 p.m. (sharp)</div>
					</div>

					<div class="ticket__detail">
						<div>Place</div>
						<div>ABF Sports Hall</div>
					</div>
				</div>
				<div class="ticket__extra">A Taste of Success</div>
			</div>
		</div>
	);
}
